/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useEffect, useState } from "react";
import { Button, Modal } from "react-materialize";
import $ from "jquery";

export default function ModalError({
  header,
  content,
  callbackEvent,
  timeoutMs = 10000,
  height = 250 }) {
  const [isOpen, setOpen] = useState(true);
  const [modalHeight, setModalHeight] = useState(height || "auto");
  const contentRef = useRef(null);

  useEffect(() => {
    // วัดความสูงเนื้อหาหลัง render
    if (contentRef.current) {
      const realHeight = contentRef.current.offsetHeight;
      setModalHeight(realHeight + 120 + "px");
    }
  }, [content, header]);

  let btns = [
    <div className="header">{header}</div>,
    <Button
      flat
      modal="close"
      node="button"
      waves="red"
      className="modal-close"
    >
      <i className="material-icons">close</i>
    </Button>,
  ];

  let timeout = "";
  const handleEvents = {
    OnComplete: function () {
      timeout = setTimeout(function () {
        $("body").css({ overflow: "auto" });
        setOpen(false);
        if ("OnClose" in callbackEvent) {
          callbackEvent.OnClose();
        }
      }, timeoutMs);
    },
    OnClose: function () {
      $("body").css({ overflow: "auto" });
      setOpen(false);
      if ("OnClose" in callbackEvent) {
        callbackEvent.OnClose();
      }
      if (timeout != "") {
        clearTimeout(timeout);
      }
    } };

  if (!isOpen) {
    return "";
  }
  return (
    <Modal
      key="modal-error"
      actions={btns}
      bottomSheet={false}
      fixedFooter={false}
      className="modal-user"
      id="modal-error"
      open={true}
      options={{
        dismissible: true,
        endingTop: "10%",
        inDuration: 250,
        onCloseEnd: null,
        onCloseStart: handleEvents.OnClose,
        onOpenEnd: null,
        onOpenStart: handleEvents.OnComplete,
        opacity: 0.5,
        outDuration: 250,
        preventScrolling: true,
        startingTop: "5%" }}
      root={document.getElementById("root")}
      style={{ height: modalHeight }}
    >
      <div id="modal-error-content" ref={contentRef}>
        <a className="btn-floating waves-effect waves-light red">
          <i className="material-icons">close</i>
        </a>
        <div
          className="text"
          style={{ fontSize: "16px" }}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </Modal>
  );
}

